<template>
	<div class="userlist">
		<div class="btnbox"></div>
		<div class="tablebox">
			<div class="thead">
				我的分销商等级: 
				<span :style="oncolor(appdata.myinfo.buyer_level)">{{appdata.myinfo.buyer_level}}</span>
				<i class="el-icon-question i" @click="onadd"></i>
			</div>
			<div class="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%" row-key="id" :tree-props="{children: 'children'}">
					<el-table-column prop="username" label="用户名" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="nickname" label="姓名" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="mobile" label="手机号" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="qq" label="QQ" align="center" header-align="center">
					</el-table-column>
					<el-table-column prop="buyer_level_str" label="分销商等级" align="center" header-align="center">
						<template slot-scope="scope">
							<div :style="oncolor(scope.row.buyer_level_str)">{{scope.row.buyer_level_str}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="children_num" label="团队会员数" align="center" header-align="center">
					</el-table-column>
				</el-table>
			</div>
		</div>
		<div class="pagediv">
			<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
				:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
				@current-change="handleCurrentChange" @size-change="handleSizeChange">
			</el-pagination>
		</div>
		
		<el-dialog title="分销商等级升级说明" :visible.sync="show" width="650px" :before-close="onclose">
			<div class="info" v-html="info"></div>
			<el-table :data="tabledata" style="width: 100%" border>
				<el-table-column prop="dqdj" label="当前等级" align="center" header-align="center" width="130px">
				</el-table-column>
				<el-table-column prop="mbdj" label="目标等级" align="center" header-align="center" width="140px">
				</el-table-column>
				<el-table-column prop="sjtj" label="升级条件" align="center" header-align="center">
				</el-table-column>
			</el-table>
			<p class="myjg" style="margin-top: 12px;">补充：升级需系统申请，审核通过后生效，最终解释权归平台所有。</p>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Userlist',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				show: false,
				info: "",
				tabledata:[{
					dqdj: "普通用户（C）",
					mbdj: "中级分销商（A）",
					sjtj: "团队60天累计订单满4500单（有效订单为准）",
				},{
					dqdj: "中级分销商（A）",
					mbdj: "高级分销商（AA）",
					sjtj: "1. 团队有10名A级成员；2. 团队60天累计订单满5万单（需同时满足）",
				}]
			}
		},
		mounted() {
			this.onlist();
			this.uinfo();
		},
		
		inject: ['appdata'],
		
		methods: {
			handleCurrentChange() {
				this.onlist();
			},
		
			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},
			
			onlist() {
				var obj = {};
				obj.page = this.page;
				obj.limit = this.pageSize;
					
				this.$axios.post('api/user/user_distribution_user_list', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			oncolor(val) {
				if(val == 'AA') {
					return 'color: #ff4714'
				}
				
				if(val == 'A') {
					return 'color: #3eed0f'
				}
				
				if(val == 'C') {
					return 'color: #0e88ed'
				}
				
				return "";
			},
			
			onclose() {
				this.show = false;
			},
			
			onadd() {
				this.show = true;
			},
			
			uinfo() {
				this.$axios.get('api/user/user_distribution_current_info').then(res => {
					if (res.data.code == 0) {
						this.info = res.data.data.info;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.userlist {
		height: 100%;
	}
	
	.tablediv {
		height: calc(100% - 37px);
	}
	
	.tablebox {
		height: calc(100% - 72px);
	}
	
	.thead {
		font-size: 18px;
		margin-bottom: 10px;
		color: #909399;
		display: flex;
		align-items: center;
		
		.i {
			font-size: 18px;
			margin-left: 14px;
			cursor: pointer;
			color: #D8DBDD;
		}
	}
	
	.info {
		margin-bottom: 14px;
	}
</style>


// WEBPACK FOOTER //
// src/components/buyer/userlist.vue